export default "<voyado-collection-mobile-actions>\n</voyado-collection-mobile-actions>";